
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote-form",
      function () {
        return require("private-next-pages/quote-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote-form"])
      });
    }
  